import { Layout, Typography, Space } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import './UnderConstruction.css';

const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const UnderConstruction = () => (
  <Layout className="maintenance-layout">
    <Content className="maintenance-content">
      <Space direction="vertical" align="center" size="large">
        <ToolOutlined className="maintenance-icon" />
        <Title level={2} className="maintenance-title">
          Portfolio refresh in progress
        </Title>
        <Paragraph type="secondary" className="maintenance-copy">
          The new experience is coming together. Please check back soon!
        </Paragraph>
      </Space>
    </Content>
    <Footer className="maintenance-footer">
      Copyright {new Date().getFullYear()} Marcos Cortorreal | Shrimp Domain
    </Footer>
  </Layout>
);

export default UnderConstruction;
